import { render } from "./LwDialog.vue?vue&type=template&id=fb98bafe&scoped=true"
import script from "./LwDialog.vue?vue&type=script&lang=js"
export * from "./LwDialog.vue?vue&type=script&lang=js"

import "./LwDialog.vue?vue&type=style&index=0&id=fb98bafe&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb98bafe"]])

export default __exports__